"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _assetsPath = _interopRequireDefault(require("../utils/assetsPath"));
var halflings = "".concat(_assetsPath["default"], "/Icons/halflings.png");
var Frodo = _styledComponents["default"].span.withConfig({
  displayName: "HalflingIcon__Frodo",
  componentId: "sc-19j8l2y-0"
})(["display:inline-block;vertical-align:text-top;height:1em;width:1.1em;background-image:url(", ");"], halflings);
var _default = Frodo;
exports["default"] = _default;
//# sourceMappingURL=HalflingIcon.js.map